module.exports = __webpack_public_path__ + "assets/img/dgoods-step2-active-green.fa9b0ef6.svg";